/**
 * Category labels for Public Mentions cards (not PRIMARY TARGET).
 */

const REGISTRY_HOST_HINTS = [
  'firme.ro',
  'listafirme.ro',
  'termene.ro',
  'risco.ro',
  'opencorporates.com',
  'companieshouse.gov.uk',
  'datefirme.ro',
  'romanian-companies.eu',
  'handelsregister.de',
  'infogreffe.fr',
  'kvk.nl',
  'northdata.com',
];

const SOCIAL_HOST_RE =
  /linkedin\.com|facebook\.com|instagram\.com|twitter\.com|x\.com|tiktok\.com|youtube\.com|reddit\.com/i;

const PRESS_HOST_RE =
  /profit\.ro|hotnews|digi24|mediafax|reuters|bloomberg|bbc\.|guardian|adevarul|g4media|biziday|zf\.ro|wall-street|startupcafe|forbes|economica/i;

function hostFromUrl(url) {
  try {
    const h = new URL(String(url || '')).hostname.toLowerCase();
    return h.startsWith('www.') ? h.slice(4) : h;
  } catch {
    return '';
  }
}

/**
 * @param {object} res
 * @returns {'MEDIA / PRESS'|'SOCIAL'|'REGISTRY'}
 */
export function classifyMentionCategory(res) {
  if (!res || typeof res !== 'object') return 'MEDIA / PRESS';

  const dem = String(res.secondary_demotion_reason || '');
  const sourceType = String(res.source_type || '');
  const host = hostFromUrl(res.url);
  const hay = `${res.title || ''} ${res.snippet || ''} ${res.url || ''}`.toLowerCase();

  const isRegistry =
    dem === 'registry_pfa' ||
    dem === 'name_variation' ||
    sourceType === 'Business Index' ||
    sourceType === 'Legal Record' ||
    REGISTRY_HOST_HINTS.some((h) => host === h || host.endsWith(`.${h}`)) ||
    /\bpfa\b|\bsrl\b|\bcui\b|registru|comertului|onrc/i.test(hay);

  if (isRegistry) return 'REGISTRY';

  if (
    sourceType === 'Social Profile' ||
    SOCIAL_HOST_RE.test(host) ||
    SOCIAL_HOST_RE.test(hay)
  ) {
    return 'SOCIAL';
  }

  if (PRESS_HOST_RE.test(host) || PRESS_HOST_RE.test(hay) || sourceType === 'Search Engine') {
    return 'MEDIA / PRESS';
  }

  return 'MEDIA / PRESS';
}
